const getPrescriberZip = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    if (address['Zip Code']) {
      return address['Zip Code'];
    }
    return null;
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    if (address['Zip Code']) {
      return address['Zip Code'];
    }
    return null;
  }
  return null;
};

export default getPrescriberZip;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberZip.js